export enum Language {
	enUK = 'enUK',
	slSI = 'slSI',
}
